__turbopack_context__.v({
  "fieldContainer": "RegPlateInput-module__qEgt3a__fieldContainer",
  "inputField": "RegPlateInput-module__qEgt3a__inputField",
  "validationError": "RegPlateInput-module__qEgt3a__validationError",
});
